import React, { useState } from 'react';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users } from 'lucide-react';
import { cn } from '../../lib/utils';

export function PhoneBankSchedulerTool() {
  const [fileSize, setFileSize] = useState('20000');
  const [callsPerHour, setCallsPerHour] = useState('25');
  const [shiftDuration, setShiftDuration] = useState('3');
  const [days, setDays] = useState('14');

  const fSize = parseInt(fileSize) || 0;
  const cPh = parseInt(callsPerHour) || 1;
  const shHr = parseFloat(shiftDuration) || 1;
  const d = parseInt(days) || 1;

  const totalCalls = fSize;
  const callsPerShift = cPh * shHr;
  const totalShiftsNeeded = Math.ceil(totalCalls / callsPerShift);
  const shiftsPerDay = Math.ceil(totalShiftsNeeded / d);

  return (
    <div className="grid lg:grid-cols-2 gap-8 text-left">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">Voter / Donor File Setup</h3>
          <div>
            <label className="text-[10px] uppercase font-bold text-gray-400">Total Contacts to Call</label>
            <Input type="number" value={fileSize} onChange={e => setFileSize(e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Calls / Vol / Hour</label>
              <Input type="number" value={callsPerHour} onChange={e => setCallsPerHour(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Shift Length (Hrs)</label>
              <Input type="number" value={shiftDuration} onChange={e => setShiftDuration(e.target.value)} />
            </div>
          </div>
          <div>
            <label className="text-[10px] uppercase font-bold text-gray-400">Days to Complete List</label>
            <Input type="number" value={days} onChange={e => setDays(e.target.value)} />
          </div>
        </Card>
      </div>

      <div className="space-y-6">
        <Card className="p-6 bg-indigo-50 border-indigo-100 flex flex-col justify-center dark:bg-indigo-900/20 dark:border-indigo-800 h-full">
            <span className="text-[10px] uppercase font-bold text-indigo-600 block mb-2 tracking-widest">Volunteers Needed per Day</span>
            <p className="text-6xl font-black text-indigo-700 font-mono mb-4">{shiftsPerDay}</p>
            <div className="border-t border-indigo-200/50 pt-4 dark:border-indigo-800/50 text-sm">
              <span className="font-bold text-indigo-700/80 block">Total Shifts Needed: {totalShiftsNeeded.toLocaleString()}</span>
            </div>
        </Card>
      </div>
    </div>
  );
}

